// Support V1: requester-facing API wrapper (/support-cases). Used by both
// the customer portal (/portal/support) and the business-side help page
// (/app/help): the backend endpoint is identical for both requester types,
// it just reads the caller's own auth token to decide requester_type.
import { api } from "./api";

export const createCase = (payload) => api.post("/support-cases", payload).then((r) => r.data);
export const listMyCases = () => api.get("/support-cases").then((r) => r.data);
export const getMyCase = (id) => api.get(`/support-cases/${id}`).then((r) => r.data);
export const replyToMyCase = (id, text, attachmentIds = []) =>
  api.post(`/support-cases/${id}/reply`, { text, attachment_ids: attachmentIds }).then((r) => r.data);
export const uploadMyAttachment = (id, payload) =>
  api.post(`/support-cases/${id}/attachments`, payload).then((r) => r.data);
export const getMyAttachmentData = (caseId, attachmentId) =>
  api.get(`/support-cases/${caseId}/attachments/${attachmentId}/data`).then((r) => r.data);
export const submitCsat = (id, score, comment) =>
  api.post(`/support-cases/${id}/csat`, { score, comment }).then((r) => r.data);

export const CASE_QUEUES = [
  { value: "general", label: "General question" },
  { value: "technical", label: "Something's not working" },
  { value: "account_recovery", label: "Account access / recovery" },
  { value: "security", label: "Security concern" },
];
